import React, { Component } from "react";

class Portfolio extends Component {
  render() {
    if (this.props.data) {
      var projects = this.props.data.projects.map(function (projects) {
        var projectImage = "images/portfolio/" + projects.image;
        return (
          <div class="card" key={projects.title}>
            <div class="box">
              <a href={projects.url} title={projects.title} target="-blank">
                <div class="imgBx">
                  <img alt={projects.title} src={projectImage} />
                </div>
                <div class="contentBx">
                  <div>
                    <h2>{projects.title}</h2>
                    <p>
                      {projects.category}
                      <br />
                      {projects.details}
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>
        );
      });
    }

    return (
      <section id="portfolio">
        <h2 class="project-heading">Projects</h2>
        <div id="projects-all">{projects}</div>
      </section>
    );
  }
}

export default Portfolio;
